const renewalDetailsFormatter = (data, renewalData) => {

  const dataSet = data;
  dataSet["reporting_manager_id"] = data?.manager?.id||data?.manager
  console.log(data, "data")
  return dataSet;
};

  export default renewalDetailsFormatter;
  